import { router } from "@inertiajs/react"

import { csrfToken } from "./orderActions"

// Toggle a freelancer in the customer's saved shortlist (see
// Customer::FreelancersController#toggle_favorite). The heart flips
// optimistically in the page, so this stays quiet: it preserves component state
// + scroll and reloads only what the caller asks for (the Favorites nav badge,
// and on the Favorites page the list itself). The endpoint redirects back, so
// no destination is needed here.
export function toggleFavorite(slug, { only = ["navCounts"], onDone } = {}) {
  router.post(
    `/freelancers/${slug}/favorite`,
    {},
    {
      headers: { "X-CSRF-Token": csrfToken() },
      preserveScroll: true,
      preserveState: true,
      only,
      onFinish: () => onDone?.(),
    }
  )
}

// Open the customer's 1:1 chat with a freelancer (see
// Customer::FreelancersController#message). The server reuses an existing DM or
// creates one, then redirects to the Messages inbox with the thread selected —
// so this is a full visit, not a partial reload. Gating lives server-side; the
// buttons are also disabled in the UI when the customer can't message.
export function messageFreelancer(slug) {
  router.post(`/freelancers/${slug}/message`, {}, { headers: { "X-CSRF-Token": csrfToken() } })
}
